import { render, staticRenderFns } from "./taxGenerationReminder.vue?vue&type=template&id=fbf37386&scoped=true"
import script from "./taxGenerationReminder.vue?vue&type=script&lang=js"
export * from "./taxGenerationReminder.vue?vue&type=script&lang=js"
import style0 from "./taxGenerationReminder.vue?vue&type=style&index=0&id=fbf37386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf37386",
  null
  
)

export default component.exports